<template>
  <component :is="useTourLayout" v-if="actor">
    <div
      class="actor-image w-full h-96 sm:h-80 relative bg-cover bg-center bg-no-repeat"
      :style="{
        '--thumb-url': `url('${actor.thumbUrl || 'https://cdn-images.r1.cdn.pornpros.com/content/placeholders/sample_475x268.jpg.jpg?imgw=475&imgh=268'}')`,
        '--hero-thumb': `url('${actor.heroThumb || 'https://cdn-images.r1.cdn.pornpros.com/content/placeholders/model_hero_1500x380.jpg?imgw=1500&imgh=380'}')`,
      }"
    >
      <div
        class="inset-0 absolute"
        style="
          background: linear-gradient(
            210deg,
            rgba(0, 0, 0, 0) 25%,
            rgba(0, 0, 0, 0.9) 100%
          );
        "
      />
      <div class="relative w-full max-w-7xl h-full mx-auto">
        <div class="absolute inset-3 justify-between items-end flex flex-row">
          <div class="w-full leading-snug">
            <p class="text-white text-xl font-bold">
              {{ actor.name }}
            </p>
            <p class="text-white">
              Rank: {{ actor.rank }}
              <br />
              Movies: {{ actor.videoCount }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="lg:hidden text-2xl uppercase font-black my-4 px-3 text-center">
      The Hottest Videos Featuring {{ actor.name }}
    </div>
    <UDivider
      v-if="currentSite.slug === 'pornplus'"
      class="hidden lg:flex my-4"
    >
      <span class="text-3xl uppercase font-black whitespace-wrap">
        The Hottest Videos Featuring {{ actor.name }}
      </span>
    </UDivider>

    <SectionContainer
      :title="
        currentSite.slug === 'pornplus'
          ? null
          : `${currentSite.name} ${actor.name} Movies`
      "
    >
      <div class="card-grid">
        <ReleaseCard
          v-for="release in releases.items"
          :key="release.id"
          :release="release"
          :vertical="useVerticalCards"
        />
      </div>
    </SectionContainer>
  </component>
</template>

<script setup>
  useRedirectInAgeRestrictedArea()

  const currentSite = inject("currentSite")
  const route = useRoute()
  const { notFoundUrl, useVerticalCards, useTourLayout } = useSiteSettings(
    currentSite.value,
  )
  const inAgeRestrictedLocation = inject("inAgeRestrictedLocation")

  const [{ data: actor }, { data: releases }] = await Promise.all([
    useApi(
      `/api/actors/${route.params.slug}?age_restricted=${inAgeRestrictedLocation}`,
    ),
    useApi(
      `/api/actors/${route.params.slug}/releases?age_restricted=${inAgeRestrictedLocation}`,
    ),
  ])

  if (!actor.value) {
    navigateTo(notFoundUrl, { external: true, statusCode: 302 })
  } else {
    useSiteSeo({
      actorName: actor.value.name,
      actorNames: actor.value.name,
      defaultDescription:
        "Watch {{{ actorName }}} {{ siteName }} videos in 4K HD on {{ siteName }}. Updated weekly, start watching all of {{ gender }} porn movies right now.",
      defaultTitle: "{{{ actorName }}} 4K HD Porn Videos: {{ siteName }}",
      pageNumber: route.query.page,
    })
  }
</script>

<style lang="scss" scoped>
  .actor-image {
    background-image: var(--thumb-url);

    @media (min-width: 768px) {
      background-image: var(--hero-thumb);
    }
  }
</style>
